import type { ReactNode } from "react";
import { cn } from "@/lib/utils";

type BadgeColor =
  | "blue"
  | "orange"
  | "emerald"
  | "green"
  | "amber"
  | "slate"
  | "gray";

const COLOR_CLASSES: Record<BadgeColor, string> = {
  blue: "border-blue-300 bg-blue-50 text-blue-700 dark:border-blue-700 dark:bg-blue-950 dark:text-blue-400",
  orange:
    "border-orange-300 bg-orange-50 text-orange-700 dark:border-orange-700 dark:bg-orange-950 dark:text-orange-400",
  emerald:
    "border-emerald-300 bg-emerald-50 text-emerald-700 dark:border-emerald-700 dark:bg-emerald-950 dark:text-emerald-400",
  green:
    "border-green-300 bg-green-50 text-green-700 dark:border-green-700 dark:bg-green-950 dark:text-green-400",
  amber:
    "border-amber-300 bg-amber-50 text-amber-700 dark:border-amber-700 dark:bg-amber-950 dark:text-amber-400",
  slate:
    "border-slate-300 bg-slate-100 text-slate-600 dark:border-slate-600 dark:bg-slate-800 dark:text-slate-400",
  gray: "border-gray-300 bg-gray-50 text-gray-700 dark:border-gray-600 dark:bg-gray-800 dark:text-gray-400",
};

interface DataTableBadgeProps {
  children: ReactNode;
  color?: BadgeColor;
  className?: string;
}

/**
 * A badge styled for use inside data tables.
 * @param children - The badge label
 * @param color - Optional color variant, defaults to "slate"
 * @param className - Additional CSS classes
 */
export function DataTableBadge({
  children,
  color = "slate",
  className,
}: DataTableBadgeProps) {
  return (
    <span
      className={cn(
        "inline-flex items-center rounded-md border px-2.5 py-0.5 text-xs font-semibold",
        COLOR_CLASSES[color],
        className,
      )}
    >
      {children}
    </span>
  );
}
